import { applicationSettings } from '../../settings/application';

const screenSavers = {
  bror: './images/ss/bror_screensaver.mp4',
  jonaxel: './images/ss/jonaxel_screensaver.mp4',
  boaxel: './images/ss/boaxel_screensaver.mp4',
  aurdal: './images/ss/aurdal_screensaver.mp4',
  ivar: './images/ss/ivar_screensaver.mp4',
  elvarli: './images/ss/elvarli_screensaver.mp4',
};

export default () => {
  if (screenSavers.hasOwnProperty(applicationSettings.applicationName))
    throw new Error(
      `${applicationSettings.applicationName} has no screensaver`
    );

  return screenSavers[applicationSettings.applicationName.toLowerCase()];
};
